import React from "react";
import { Box, Stack } from "@mui/material";
import SideNav from "../../components/commonComponents/Sidebar/SideNav";
import ActionButton from "../../components/commonComponents/Buttons/ActionButton";
import { Add, Save } from "@mui/icons-material";
import AddLoopCampaign from "./ModalContent/AddLoopCampaign";
import LoopsListing from "./listings/LoopsListing";
import LoopsListFilter from "./filters/LoopsListFilter";
import { StyledMainBox } from "../../components/commonComponents/StyledComponents/styled";
import { resetPicturesData } from "../../api_calls/pictureRequests";
import { resetBrandReportView } from "../../api_calls/utils";
import AccessControl from "../../components/commonComponents/Hoc/AccessControl";
import { checkUserPermissions } from "../../api_calls/userManagement";
import { useSelector } from "react-redux";
import { FileProvider } from "./ModalContent/WizardSteps/FileProvider";
import { resetLoopsData } from "../../api_calls/loopCampaign";

const LoopBasedCampaign = () => {
  const Pictures = useSelector((state) => state.userSelections);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const allowedAccessRights = checkUserPermissions();
  const permissionScope = allowedAccessRights.allowed_access;
  const closeModal = () => {
    resetLoopsData();
    setIsModalOpen(false);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  React.useEffect(() => {
    resetBrandReportView();
  }, []);

  return (
    <>
      <StyledMainBox component="main">
        {/* <Box height={30} /> */}
        <h1>Loop-based Campaigns</h1>
        {/* ============ chose data fields button =========== */}
        {permissionScope.picture_list_can_edit === true && (
          <Stack direction="row" spacing={2}>
            <ActionButton
              onClick={(e) => {
                e.preventDefault();
                openModal();
              }}
              label={"New Campaign"}
              icon={<Add />}
            />
          </Stack>
        )}

        {/* --------------- filters ------------- */}
        <Box height={30} />
        {
          typeof Pictures.loop_names_info !== "undefined" && typeof Pictures.store_names_info !== "undefined" && typeof Pictures.companies_info !== "undefined" && typeof Pictures.visual_names_info !== "undefined" && <LoopsListFilter />
        }

        {/* ============== pictures listing ============ */}
        <Box height={30} />
        <LoopsListing />
      </StyledMainBox>
      {/* ============ modal popup for different actions ========== */}
      {isModalOpen && (
        <FileProvider>
          <AddLoopCampaign open={isModalOpen} onClose={closeModal} size={"md"} closeModal={closeModal} usedFor={"add"} />
        </FileProvider>

      )}
    </>
  );
};

export default AccessControl(LoopBasedCampaign, ["picture_list_can_view", "picture_list_can_edit"], [], ["campaigns_section", "pictures"]);
